import React from 'react'
import { IMenuStructure } from '../../IMenuStructure'

interface IProps extends IMenuStructure {}

export const MenuItem = ({
  icon,
  title,
  path,
  classNames,
  isRender,
}: IProps) => {
  if (!isRender) {
    return null
  }

  return (
    <a href={path} className={classNames.join(' ')} title={title}>
      <i className={'icon icon-on icon-' + icon} />
      <i className={'icon icon-off icon-' + icon + '-neg'} />
    </a>
  )
}
